import Modal from 'react-bootstrap/Modal';
import React, { useState,useEffect } from 'react';
import {MDBTable, MDBTableHead, MDBTableBody, MDBBtn } from 'mdb-react-ui-kit';
import { useNavigate } from 'react-router-dom';
import {BiAlarmExclamation } from "react-icons/bi";


function ModalRejAlert(props) {

  const navigate = useNavigate();

  const cancel = () =>{
    navigate('/dashboard');
  }
//console.log(props.tabkey)
  return (

    <Modal
      {...props}
      size="s"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      key={props.Selected}
      backdrop="static"
    >
      {/* <Modal.Header >
        <Modal.Title id="contained-modal-title-vcenter" style={{fontSize:"16px", color:'orange', textAlign:'center'}}>
          Alert 
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body style={{ textAlign:'center'}}>
      <Modal.Title  style={{fontSize:"20px", color:'orange', textAlign:'center', margin:'20px'}}>
      <BiAlarmExclamation style={{fontSize:"25px", marginTop:"-5px"}} /> Alert 
        </Modal.Title>
           <p>Please Upload Last Quarter Data</p>
        
      </Modal.Body>
      <Modal.Footer>
        <button className="ripple ripple-surface ripple-surface-light  btn-primary" onClick={props.onHide}>Countinue Upload</button>
        <button className="ripple ripple-surface ripple-surface-light  btn-primary" onClick={cancel}>Cancel Upload</button>

      </Modal.Footer>
    </Modal>
  );
}

export default ModalRejAlert